import React from 'react';
import { Calendar, ExternalLink } from 'lucide-react';

const webinars = [
  {
    title: 'Seller Pro Weekly Webinar',
    description: 'Join us every week for live tips, strategies, and Q&A on Amazon & Walmart & eBay selling.',
    emoji: '📦',
    link: 'https://calendly.com/contact-multisellerpro/weekly-webinar',
    color: 'from-teal-500 to-blue-600',
    bg: 'bg-teal-50',
    border: 'border-teal-200',
    btnColor: 'from-teal-500 to-blue-600',
  },
  {
    title: 'Influencer Pro Weekly Webinar',
    description: 'Weekly live sessions covering AIP, Creator Connections, and more.',
    emoji: '🎬',
    link: 'https://calendly.com/contact-multisellerpro/mip-weekly-webinar',
    color: 'from-purple-500 to-pink-600',
    bg: 'bg-purple-50',
    border: 'border-purple-200',
    btnColor: 'from-purple-500 to-pink-600',
  },
];

const WebinarsPage = ({ user }) => {
  return (
    <div className="max-w-3xl mx-auto py-12 px-6">

      <div className="mb-10">
        <div className="flex items-center gap-2 mb-2">
          <Calendar size={22} className="text-teal-600" />
          <h1 className="text-3xl font-bold text-gray-800">MultiSellerPro Webinars</h1>
        </div>
        <p className="text-gray-500">Live weekly sessions to help you grow your business.</p>
      </div>

      <div className="flex flex-col gap-6">
        {webinars.map((w) => (
          <div
            key={w.title}
            className={`bg-white rounded-2xl shadow-lg border ${w.border} overflow-hidden`}
          >
            {/* Top color bar */}
            <div className={`h-2 bg-gradient-to-r ${w.color}`} />

            <div className="p-6">
              <div className="flex items-center gap-3 mb-3">
                <div className={`w-12 h-12 rounded-xl ${w.bg} flex items-center justify-center text-2xl flex-shrink-0`}>
                  {w.emoji}
                </div>
                <div>
                  <h2 className="text-xl font-bold text-gray-800">{w.title}</h2>
                  <p className="text-gray-500 text-sm mt-0.5">{w.description}</p>
                </div>
              </div>

              <a
                href={w.link}
                target="_blank"
                rel="noopener noreferrer"
                className={`mt-4 w-full py-3 bg-gradient-to-r ${w.btnColor} text-white rounded-xl font-bold hover:opacity-90 transition shadow flex items-center justify-center gap-2 text-sm`}
              >
                <ExternalLink size={16} /> Click Here to Sign Up
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WebinarsPage;